import { createStore } from "vuex";
import { auth } from "./auth.module";
import { company } from "@/store/company.module";
import { stomp } from "@/store/stomp.module"
import { ticket } from "@/store/ticket.module";
import { column } from "@/store/column.module";

const store = createStore({
    modules: {
        auth,
        company,
        stomp,
        ticket,
        column,
    },
    state:{
      employmentType:['Führungskraft','Mitarbeiter','Leiharbeitskraft']
    },

    mutations:{
        initializeStore(state, storedState) {
            if (storedState) {
                // Assign the stored state to the Vuex state
                Object.assign(state, storedState);
            }
        }
    },

    getters: {
        // Define the getter for companyData
        employmentType(state) {
            return state.employmentType;
        },
    },

    plugins: [
        (store) => {
            store.subscribe((mutation, state) => {
                // Save company data to localStorage
                if(state.company.companyData) {
                    localStorage.setItem('companyData', JSON.stringify(state.company.companyData));
                }
                if(state.column.columnData) {
                    localStorage.setItem('columnData', JSON.stringify(state.column.columnData));
                }
                if(state.stomp.connected){
                    localStorage.setItem('connectionData', JSON.stringify(state.stomp.connected));
                }
            });
        },
    ],
});


const storedStateCompany = JSON.parse(localStorage.getItem("companyData"));
const storedStateStomp = JSON.parse(localStorage.getItem("connectionData"));
const storedStateColumn = JSON.parse(localStorage.getItem("columnData"));
store.commit("company/storeCompany", storedStateCompany);
store.commit("stomp/setConnectionState", storedStateStomp);
store.commit("column/setColumns", storedStateColumn);

export default store;